<template>
    <div
        class="list-mask"
        @click.self="close"
        @touchstart.capture="touchstart"
        @touchmove.capture="touchmove"
    >
        <ol class="mobile list">
            <slot></slot>
        </ol>
    </div>
</template>
<script>
//mobile action style
export default {
    emits: ['close'],
    data: function() {
        return {
            cache: {
                done: false,
                containerHeight: 0,
                cotentHeight: 0,
                el: null,
                maskEl: null
            },
            startY: 0
        };
    },
    methods: {
        close() {
            this.$emit('close');
        },
        prepareData() {
            let listEl = this.$el.querySelector('.mobile.list');
            if (!listEl) {
                return;
            }
            this.cache.el = listEl;
            this.cache.containerHeight = listEl.offsetHeight;
            this.cache.cotentHeight = listEl.scrollHeight;
            this.cache.done = true;
        },
        touchmove(e) {
            !this.done && this.prepareData();
            if (
                this.cache.containerHeight == this.cache.cotentHeight ||
                e.target == this.$el
            ) {
                return e.preventDefault();
            }
            //content can scroll
            let endY = e.touches[0].pageY;
            let deltaY = endY - this.startY;
            if (deltaY < 0) {
                //finger up
                if (
                    this.cache.el.scrollTop + this.cache.containerHeight ==
                    this.cache.cotentHeight
                ) {
                    e.preventDefault();
                }
                return; //can scroll content
            }
            // finger down
            if (this.cache.el.scrollTop == 0) {
                e.preventDefault();
            }
            //can scroll
        },
        touchstart(e) {
            this.startY = e.touches[0].pageY;
        }
    }
};
</script>
<style lang="scss">
.list-mask {
    position: fixed;
    width: calc(100% + 4px);
    left: -2px;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: rgba(0, 0, 0, 0.6);
    z-index: var(--level-subhigh);
    ol {
        max-height: 80vh;
        overflow: auto;
        li {
            width: 100%;
            text-align: center;
            background: white;
            height: 44px;
            line-height: 44px;
            font-size: 14px;
            color: #505050;
            border-bottom: 1px solid var(--color-border);
            &.selected {
                color: var(--color-theme);
                background: white;
            }
            &:hover {
                color: #505050;
                background-color: #f2f2f2;
            }
            &:last-child {
                border-bottom: none;
            }
        }
    }
}
</style>
